var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.555 22.9999L15.0675 3.24575C18.4155 3.24575 19.4715 3.61287 19.624 5.11138C19.624 5.11138 21.8699 4.27396 23.0027 2.57318C18.5823 0.524877 14.1409 0.432502 14.1409 0.432502L11.5492 3.58911L11.555 3.58871L8.96337 0.432007C8.96337 0.432007 4.52182 0.524482 0.102051 2.57278C1.23382 4.27356 3.48064 5.11098 3.48064 5.11098C3.634 3.61238 4.68875 3.24525 8.01427 3.24288L11.555 22.9999Z",
    fill: "#FFBB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.1e566b36fb926e49fbd7bdc327dd9884.svg";
export { ForwardRef as ReactComponent };